/**
 * @desc getRoleByUserNo
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<Array<defs.appCenter.AppDomainRoleResponseDto>>;
export function request(
  params: API.appCenter.appFacadeImpl.getRoleByUserNo.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/app/role/list/userNo`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
